module.exports = __webpack_public_path__ + "img/supplier.1049e3a2.svg";